import { useAppSelector } from '../../../../state/hooks'
import { selectLineItemCurrentTab } from '../../../../state/slices/uiStateSlice'
import { FulfilmentType } from '../../../../models/fulfilment'
import { LineItem } from '../../../../models/line-item'

export interface LineItemExpandedProps {
  lineItem: LineItem
  editAllowedForConfirmed?: boolean
  elementToFocus?: 'quantity' | 'price'
  onSelectFulfilmentType?: (
    type: FulfilmentType,
    fulfilmentOutletId?: string
  ) => void
}

export const useLineItemExpandedModel = (props: LineItemExpandedProps) => {
  const currentTab = useAppSelector(selectLineItemCurrentTab)

  return { currentTab }
}
